import facebookIcon from "../../public/socialNetworkIcons/Facebook.png"
import instagramIcon from "../../public/socialNetworkIcons/instagramIcon.svg"
import yelpIcon from "../../public/socialNetworkIcons/Yelp.png"

const socialNetworkItems = [
    {
        href:"https://www.facebook.com/profile.php?id=100075400827302",
        iconRef:facebookIcon,
        height: "30px"
    },
    {
        href:"",
        iconRef:instagramIcon,
        height: "30px"
    },
    {
        href:"https://www.yelp.com/biz/mily-travel-tampa",
        iconRef:yelpIcon,
        height: "40px"
    },
]
export default socialNetworkItems;